import { Button, Paper, Popper, Stack, Typography } from '@mui/material';
import type { GcpNetworkConnectivityConfig } from '@repo/api-gw-sdk';
import { useState } from 'react';

import {
  GcpNetworkSelect,
  type GcpNetwork,
} from '@/components/selectors/gcpNetworkSelect';

export const GcpNetworkSelectionDialog = ({
  accountId,
  onClose,
  anchorEl,
  config,
}: {
  accountId: string;
  onClose: (network: GcpNetwork | undefined) => void;
  anchorEl: HTMLElement | null;
  config: GcpNetworkConnectivityConfig[];
}) => {
  const [network, setNetwork] = useState<GcpNetwork | undefined>(undefined);

  return (
    <Popper anchorEl={anchorEl} disablePortal placement='bottom-start' open>
      <Paper
        sx={{
          width: '308px',
          padding: '24px',
          borderRadius: '4px',
          marginTop: '-33px',
          boxShadow: 'var(--mui-customShadows-lg)',
        }}
      >
        <Stack gap='24px'>
          <Typography>Choose a Network</Typography>
          <GcpNetworkSelect
            disabledItems={config.map((c) => ({
              networkName: c.network,
              project: c.networkHostProject,
            }))}
            network={network}
            accountId={accountId}
            onChange={(network) => {
              setNetwork(network);
            }}
          />
          <Stack direction='row' gap='8px' justifyContent={'flex-end'}>
            <Button onClick={() => onClose(undefined)}>Cancel</Button>
            <Button
              onClick={() => onClose(network)}
              variant='contained'
              disabled={!network}
            >
              Customize Network
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Popper>
  );
};
